import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import AppNav from "./AppNav";
import Footer from "./Footer";
import PageLoader from "./PageLoader";

const AppLayout = () => {
	return (
		<div className='flex min-h-screen flex-col bg-surface'>
			<AppNav />
			<main className='flex-1 pt-14'>
				<Suspense fallback={<PageLoader />}>
					<Outlet />
				</Suspense>
			</main>
			<Footer />
		</div>
	);
};

export default AppLayout;
